<template>
  <b-card body-bg-variant="light"
          header="Scientific part"
          header-bg-variant="dark"
          header-text-variant="light">

    <p class="p-form-label">
      Attachment <br/>
      <span class="grey--text m-0">Fill scientific part template and attach as PDF. Max size 10MB</span>
    </p>
    <attachment-input v-model="data.general.attachments"
                      :attachment-url="'/documents/' + $route.params.id"
                      :disabled="!editable"
                      class="mt-1"/>

    <div class="mt-3">
      <a :href="wordTemplateUrl">
        Download MS Word template for Scientific part
      </a>
    </div>

  </b-card>
</template>

<script>
  import AttachmentInput from '@/components/AttachmentInput';

  export default {
    name: 'ScientificPart',
    props: {
      value: undefined,
      validation: undefined,
      editable: {
        type: Boolean,
        default: true,
      },
    },
    components: { AttachmentInput },
    data() {
      return {
        // eslint-disable-next-line vue/max-len
        wordTemplateUrl: 'https://synchrotron.uj.edu.pl/documents/1457771/159877661/Scientific-part-template_2025_uniwersalne.docx/651eaae0-73d9-4bd4-82a2-7b49ae06aad1',
        data: this.value,
        $v: this.validation,
      };
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data.general === undefined) this.data.general = {};
        },
        deep: true,
      },
    },
  };
</script>
